if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      if (FoxTheme.config.motionReduced) return;
      this.promotion = this.querySelector('.promotion');
      this.isPaused = false;
      FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }
    
    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add('promotion--animated');

        // Clone the promotion content for the visual marquee effect.
        // Accessibility: only the first (original) set of items should be focusable.
        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.appendChild(this.clone);
        }

        // Mark all cloned promotions as aria-hidden and remove them from the tab order.
        const promotions = this.querySelectorAll('.promotion');
        promotions.forEach((promotion, index) => {
          if (index === 1) return; // keep the first/original one focusable

          promotion.setAttribute('aria-hidden', 'true');
          // Disable focus on interactive elements inside clones
          promotion
            .querySelectorAll('a, button, [tabindex]')
            .forEach((el) => {
              // Avoid breaking elements that are already explicitly removed from tab order
              if (!el.hasAttribute('data-original-tabindex')) {
                if (el.hasAttribute('tabindex')) {
                  el.setAttribute('data-original-tabindex', el.getAttribute('tabindex'));
                }
              }
              el.setAttribute('tabindex', '-1');
              el.setAttribute('aria-hidden', 'true');
            });
        });

        // Find the control button in the parent section
        this.controlBtn = this.closest('.section--scrolling-promotion').querySelector('.scrolling-promotion__control-btn');
        this.pauseIcon = this.closest('.section--scrolling-promotion').querySelector('.scrolling-promotion__pause-icon');
        this.playIcon = this.closest('.section--scrolling-promotion').querySelector('.scrolling-promotion__play-icon');

        // Add event listener for play/pause control
        if (this.controlBtn) {
          this.controlBtn.addEventListener('click', this.toggleScroll.bind(this));
        }

        // Add hover event listeners if pause on hover is enabled
        if (this.hasAttribute('data-pause-on-hover')) {
          this.addEventListener('mouseenter', this.scrollingPause.bind(this));
          this.addEventListener('mouseleave', this.scrollingPlay.bind(this));
        }

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this);
      }
    }

    toggleScroll() {
      if (this.isPaused) {
        this.scrollingPlay();
      } else {
        this.scrollingPause();
      }
    }

    scrollingPlay() {
      // Don't play if hovering and pause-on-hover is enabled
      if (this.hasAttribute('data-pause-on-hover') && this.matches(':hover')) {
        return;
      }
      
      this.classList.remove('scrolling-promotion--paused');
      this.isPaused = false;
      
      // Update button state and icon visibility
      if (this.controlBtn) {
        this.controlBtn.setAttribute('aria-label', 'Pause scrolling promotion');
        this.controlBtn.classList.remove('is-paused');
      }
      if (this.pauseIcon) {
        this.pauseIcon.style.display = 'block';
      }
      if (this.playIcon) {
        this.playIcon.style.display = 'none';
      }
      
      // Resume the animation for all promotions
      this.querySelectorAll('.promotion').forEach(promotion => {
        promotion.style.animationPlayState = 'running';
      });
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
      this.isPaused = true;
      
      // Update button state and icon visibility
      if (this.controlBtn) {
        this.controlBtn.setAttribute('aria-label', 'Play scrolling promotion');
        this.controlBtn.classList.add('is-paused');
      }
      if (this.pauseIcon) {
        this.pauseIcon.style.display = 'none';
      }
      if (this.playIcon) {
        this.playIcon.style.display = 'block';
      }
      
      // Pause the animation for all promotions
      this.querySelectorAll('.promotion').forEach(promotion => {
        promotion.style.animationPlayState = 'paused';
      });
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}
